import { LOGIN_REQUEST, LOGIN_SUCCESS, LOGIN_FAIL } from "../constants/session";

function loginReducer(state, action) {
	if (typeof state === "undefined") {
		state = {};
	}
	switch (action.type) {
		case LOGIN_REQUEST:
			return { isAuthenticated: false };
		case LOGIN_SUCCESS:
			return {
				isAuthenticated: true,
				adminInfo: action.payload.data,
			};
		case LOGIN_FAIL:
			return { isAuthenticated: false, error: action.payload };
		default:
			return state;
	}
}

export { loginReducer };
